import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { isPremiumTier } from '@/lib/premium';
import type { SubscriptionTier } from '@sharecost/shared';

export function usePremium() {
  const { profile } = useAuth();

  return useMemo(() => {
    const tier: SubscriptionTier = profile?.subscription_tier ?? 'FREE';

    return {
      tier,
      isPremium: isPremiumTier(tier),
    };
  }, [profile?.subscription_tier]);
}
